import { useTranslation } from "react-i18next";

import { StandardFormProps } from "./StandartForm.types";

import { Section } from "../Section";
import { InvestObjects } from "../InvestObjects";
import { ClientParameters } from "../ClientParameters";
import { InvestObjectParameters } from "../InvestObjectParameters";

import styles from "./StandardForm.module.scss";

const StandardForm = ({
  isDesktop,
  isRootAdmin,
  calculatorType,
  defaultDowntimeDynamicNotEmpty,
  calculationValues,
  loansOptions,
  loans,
  activeTab,
}: StandardFormProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.inner}>
      <Section title={t("calculator_form.client_parameters.title")}>
        <ClientParameters
          calculatorType={calculatorType}
          activeTab={activeTab}
          isDesktop={isDesktop}
        />
      </Section>
      <Section title={t("calculator_form.invest_objects.title")}>
        <InvestObjects
          isRootAdmin={isRootAdmin}
          activeTab={activeTab}
          isDesktop={isDesktop}
          calculatorType={calculatorType}
          calculationValues={calculationValues}
        />
      </Section>
      <Section title={t("calculator_form.invest_object_parameters.title")}>
        <InvestObjectParameters
          activeTab={activeTab}
          isDesktop={isDesktop}
          isRootAdmin={isRootAdmin}
          defaultDowntimeDynamicNotEmpty={defaultDowntimeDynamicNotEmpty}
          loans={loans}
          calculatorType={calculatorType}
          loansOptions={loansOptions}
        />
      </Section>
    </div>
  );
};

export default StandardForm;
